import { Column, Entity, PrimaryColumn } from 'typeorm';

/**
 * TenantDetailSchema インターフェイス。
 */
export interface ITenantDetailSchema {
  id: string;
  name: string;
}

@Entity()
export class TenantDetailSchema implements ITenantDetailSchema {

  @PrimaryColumn()
    id: string;

  @Column({ nullable: true })
    name: string | null;

  constructor(tenantId: string, name: string) {
    this.id = tenantId;
    this.name = name;
  }
}
